import React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "common/loaders/Spinner";

type Props = {
    text?: string;
};

export function Loader(props: Props) {
    const { t } = useTranslation();

    return (
        <div className="flex_center_center p_20 flex_column">
            <Spinner />
            <div className="mt_20 text_small_semiBold textAlign_center">{props.text ?? t("loaders.message")}</div>
        </div>
    );
}
